export const WUD = {
  id: 31337,
  height: 6110335,
  data: {
    icon: "/imgs/icons/asset/wud.webp",
  },
};
